<template>
  <v-expansion-panels
          class="mb-4"
  >
    <v-expansion-panel>
      <v-expansion-panel-header> Tìm kiếm theo báo cáo trưởng nhóm</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card
                class="ma-0 overflow-visible"
                outlined
        >
          <validation-observer v-slot="{ handleSubmit }">

            <v-list-item class="pa-0" one-line>
              <v-list-item-content class="overflow-visible pa-0">
                <!--          <v-list-item-title class="headline mb-2">-->
                <!--            Tìm Kiếm-->
                <!--          </v-list-item-title>-->

                <v-row>
                  <v-col cols="12" md="6">
                    <validation-provider
                            name="Trưởng nhóm"
                            v-slot="{ errors }"
                            rules="required"
                    >
                      <v-autocomplete
                              v-model="filterForm.userId"
                              :items="listLeaders"
                              label="Tìm kiếm theo tên *"
                              placeholder="Tên trưởng nhóm"
                              item-text="fullName"
                              item-value="id"
                              :error-messages="errors"
                      >
                      </v-autocomplete>
                    </validation-provider>
                  </v-col>

                  <v-col cols="12" md="6">
                    <validation-provider
                            name="Chọn ngày"
                            v-slot="{ errors }"
                            rules="required"
                    >
                      <common-range-picker
                              v-model="selectRange"
                              :clearable="true"
                              :aLight="'left'"
                              :defaultRange="defaultRange"
                              @change-date-range="changeDateRange"
                      />
                      <div class="v-text-field__details mt-1">
                        <div class="v-messages theme--light error--text" role="alert">
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">
                              {{ errors[0] }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </validation-provider>

                  </v-col>
                </v-row>

                <div class="text-center mb-4">
                  <v-btn
                          class="primary mx-0"
                          @click.prevent="handleSubmit(searchReport); scrollToError()"
                  >
                    <v-icon>mdi-magnify</v-icon>Tìm kiếm
                  </v-btn>
                </div>

              </v-list-item-content>
            </v-list-item>
          </validation-observer>

        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>

import RepositoryFactory from "@/repositories/RepositoryFactory";
import { formatDate } from '@/helpers/utils'
import { userPositions } from '@/helpers/constants'
const UserRepository = RepositoryFactory.get('user');
import * as moment from 'moment'

export default {
  props: {
    filterForm: {
      default: () => ({}),
    },
    leader: {
      default: () => ({})
    },
  },
  data () {
    return {
      listLeaders: [],
      defaultRange: {
        startDate: moment().startOf('day').format('YYYY-MM-DD 00:00:00'),
        endDate: moment().endOf('day').format('YYYY-MM-DD 23:59:59'),
      },
      selectRange: [{
        startDate: moment().startOf('day').format('YYYY-MM-DD 00:00:00'),
        endDate: moment().endOf('day').format('YYYY-MM-DD 23:59:59'),
      }]
    }
  },
  created() {
    this.getLeaderList()
  },
  methods: {
    searchReport () {
      Bus.$emit('sale-leader-filter', this.filterForm)
    },
    changeDateRange (dateRange) {
      this.filterForm.dateRange = dateRange
      this.selectRange = dateRange
    },
 
    async getLeaderList() {
      this.loading = this.$loading.show()
      const params = {
        position: userPositions.SALE_LEADER,
        limit: 1000
      };
      const response = await UserRepository.list(params);
      this.loading.hide()
      if (response.success) {
        this.listLeaders = _.get(response, "data", []);
      }
    },
  },
}
</script>
